// angular imports
import { WritableSignal, signal } from "@angular/core";

// local imports
import { CategoryModel, RoomPropertyDto, DocumentModel } from "@app/catalog";
import { ListItemFactory } from "@app/shared";

export class RoomPropertyModel {
  public id: string = "";
  public name: WritableSignal<string>;
  public code: WritableSignal<string>;
  public subCode: WritableSignal<string>;
  public categories: WritableSignal<CategoryModel[]>;
  public documents: WritableSignal<DocumentModel[]>;
  public thumbnailUrl: WritableSignal<string>;
  public hasImageError: WritableSignal<boolean>;

  constructor()
    {
        this.name = signal<string>(undefined);
        this.code = signal<string>(undefined);
        this.subCode = signal<string>(undefined);
        this.thumbnailUrl = signal<string>(undefined);
        this.categories = signal<CategoryModel[]>([]);
        this.documents = signal<DocumentModel[]>([]);
        this.hasImageError = signal<boolean>(false);
    }

  public handleImageError() {
    this.hasImageError.set(true);
  }

  public static fromDto(dto: RoomPropertyDto) {
    let roomProperty = new RoomPropertyModel();

    roomProperty.id = dto.id;
    roomProperty.thumbnailUrl.set(dto.thumbnailUrl);
    roomProperty.name.set(dto.name);
    roomProperty.code.set(dto.code);
    roomProperty.subCode.set(dto.subcode);
    roomProperty.documents.set(dto.documents.map(doc => DocumentModel.fromDto(doc)));
    

    //TODO:DIW:At somepoint the selected categories could be passed in so CategoryModel.fromDto can have isChecked set properly.
    roomProperty.categories.set(dto.categories.map(cat=>CategoryModel.fromDto(cat, false)));
    return roomProperty;
  }

    public toListItem = (selected: boolean = false) => 
        ListItemFactory.create<RoomPropertyModel>(this.name, this.id, this, selected);
    

    public toListItem$ = (selected: WritableSignal<boolean>) =>
        ListItemFactory.create$<RoomPropertyModel>(this.name, this.id, this, selected);
}
